import {CodigoIdiomaEnum} from '../../enum/codigo-idioma-enum';
import {TemplateCabecalhoModel} from './template-cabecalho-model';
import {TemplateVariavel, TemplateVarModel} from './template-variavel-model';
import {TemplateBotaoModel} from './template-botao-model';
import {TemplateSalvamentoModel} from './template-salvamento-model';
import {TextoMidiaEnum} from '../../enum/texto-midia-enum';
import {StatusTemplateEnum} from '../../enum/status-template-enum';
import {Usuario} from '../usuario/usuario.model';
import {Conta} from '../conta.model';
import {IdNome} from '../id-nome.model';

export class TemplateModel{

  id?: number;
  nome?: string;
  tipo?: string = 'WHATSAPP';
  idioma?: CodigoIdiomaEnum;
  idiomaAuxString?: string;
  categoria?: string;
  status?: StatusTemplateEnum;
  dataCriacao?: Date;
  usuarioCriacao?: Usuario;
  dataAlteracao?: Date;
  usuarioAlteracao?: Usuario;
  templateCabecalho: TemplateCabecalhoModel = new TemplateCabecalhoModel();
  variavel: TemplateVarModel = new TemplateVarModel();
  idRodape?: number;
  textoRodape?: string;
  botoes: TemplateBotaoModel[] = [];
  conta: Conta = new Conta();
  enviadoMeta = false;
  ativo = false;
  setor?: IdNome;
  utilizado = false;
  variavelFixa = false;

  constructor(id?: number, nome?: string, idioma?: CodigoIdiomaEnum, categoria?: string, status?: StatusTemplateEnum, dataCriacao?: Date, usuarioCriacao?: Usuario, dataAlteracao?: Date, usuarioAlteracao?: Usuario, templateCabecalho?: TemplateCabecalhoModel, variavel?: TemplateVarModel, idRodape?: number ,textoRodape?: string, botoes?: TemplateBotaoModel[], conta?: Conta, ativo?: boolean, tipo?: string, utilizado?: boolean) {
    this.id = id;
    this.nome = nome;
    this.tipo = (tipo || 'WHATSAPP').toUpperCase() === 'SMS' ? 'SMS' : 'WHATSAPP';
    this.idioma = idioma;
    this.categoria = categoria;
    this.status = status;
    this.dataCriacao = dataCriacao;
    this.usuarioCriacao = usuarioCriacao;
    this.dataAlteracao = dataAlteracao;
    this.usuarioAlteracao = usuarioAlteracao;
    this.ativo = ativo ?? false;
    this.utilizado = utilizado ?? false;
    if(templateCabecalho)
      this.templateCabecalho = templateCabecalho;
    if(variavel)
      this.variavel = variavel;
    this.idRodape = idRodape;
    this.textoRodape = textoRodape;
    if(botoes)
      this.botoes = botoes;
    if(conta)
      this.conta = conta;

  }

  converterParaUsoInterno(templateSalvamento: TemplateSalvamentoModel): TemplateModel {
    this.id = templateSalvamento.id!;
    this.nome = templateSalvamento.name!;
    this.tipo = ((templateSalvamento as any).tipo || 'WHATSAPP').toString().toUpperCase() === 'SMS' ? 'SMS' : 'WHATSAPP';
    this.idioma = Object.values(CodigoIdiomaEnum).find(i => i === templateSalvamento.language);
    this.categoria = templateSalvamento.category;
    this.status = templateSalvamento.status;
    this.dataCriacao = templateSalvamento.dataCriacao!;
    this.usuarioCriacao = templateSalvamento.usuarioCriacao!;
    this.dataAlteracao = templateSalvamento.dataAlteracao!;
    this.usuarioAlteracao = templateSalvamento.usuarioAlteracao!;
    this.enviadoMeta = templateSalvamento.enviadoMeta;
    this.ativo = templateSalvamento.ativo;
    this.setor = templateSalvamento.setor;
    this.utilizado = templateSalvamento.utilizado ?? false;
    this.variavelFixa = templateSalvamento.variavelFixa ?? false;

    templateSalvamento.components.forEach(componente => {
      if(componente.type === 'HEADER'){
        this.templateCabecalho.id = componente.id;
        if(componente.format === 'TEXT'){
          this.templateCabecalho.textoOuMidia = TextoMidiaEnum.TEXTO;
          this.templateCabecalho.titulo = componente.text;
          this.templateCabecalho.format = 'TEXT';
        } else if(componente.format === 'IMAGE'){
          this.templateCabecalho.textoOuMidia = TextoMidiaEnum.MIDIA;
          this.templateCabecalho.file = componente.text;
          this.templateCabecalho.format = 'IMAGE';
        } else if(componente.format === 'VIDEO'){
          this.templateCabecalho.textoOuMidia = TextoMidiaEnum.MIDIA;
          this.templateCabecalho.file = componente.text;
          this.templateCabecalho.format = 'VIDEO';
        } else if(componente.format === 'DOCUMENT'){
          this.templateCabecalho.textoOuMidia = TextoMidiaEnum.MIDIA;
          this.templateCabecalho.file = componente.text;
          this.templateCabecalho.format = 'DOCUMENT';
        } else if(componente.format === 'MAP'){
          this.templateCabecalho.textoOuMidia = TextoMidiaEnum.MIDIA;
          this.templateCabecalho.file = componente.text;
          this.templateCabecalho.format = 'MAP';
        }
      } else if(componente.type === 'BODY' && componente.example){
        this.variavel.id = componente.id;
        this.variavel.corpo = componente.text!;
        this.variavel.variaveis = componente.example.map(ex => ({
            id: ex.id,
            variavel: ex.valor,
            numero: ex.ordem,
            tipoCampoFixo: ex.campoFixo ?? undefined
          }) as TemplateVariavel
        );
      } else if(componente.type === 'BODY' && !componente.example){
        this.variavel.id = componente.id;
        this.variavel.corpo = componente.text!;
      } else if(componente.type === 'FOOTER'){
        this.idRodape = componente.id;
        this.textoRodape = componente.text!;
      } else if(componente.type === 'BUTTONS'){
        this.botoes = componente.buttons;
      }
    });

    if(templateSalvamento.conta)
      this.conta = templateSalvamento.conta;

    return this;
  }

}
